<template>
  <el-dialog :title="$t('staffCollectedProduct.addTitle')" :visible.sync="dialogVisible" width="70%" @close="closeDialog">
    <div class="product-select-container">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="product-category">
            <el-tree 
              :data="categoryData" 
              :props="defaultProps" 
              @node-click="handleNodeClick"
              highlight-current
              default-expand-all>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="16">
          <!-- 搜索条件 -->
          <div class="search-container" style="margin-bottom: 15px;">
            <el-form :inline="true" :model="searchForm">
              <el-form-item label="商品名称">
                <el-input 
                  v-model="searchForm.prodNameLike" 
                  placeholder="请输入商品名称"
                  clearable
                  @keyup.enter.native="queryProducts"
                  style="width: 200px;">
                </el-input>
              </el-form-item>
              <el-form-item label="条码">
                <el-input 
                  v-model="searchForm.barCode" 
                  placeholder="请输入条码"
                  clearable
                  @keyup.enter.native="queryProducts"
                  style="width: 200px;">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="queryProducts">查询</el-button>
                <el-button @click="resetSearch">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <div class="product-list">
            <!-- 商品列表 -->
            <el-table 
              :data="productList" 
              border 
              style="width: 100%" 
              v-loading="loading">
              <el-table-column prop="productId" label="商品编号" align="center" width="120">
              </el-table-column>
              <el-table-column prop="prodName" label="商品名称" align="center">
              </el-table-column>
              <el-table-column label="规格" align="center" width="150">
                <template slot-scope="scope">
                  {{ scope.row.defaultSpecValue ? scope.row.defaultSpecValue.specName : '-' }}
                </template>
              </el-table-column>
              <el-table-column label="库存" align="center" width="100">
                <template slot-scope="scope">
                  {{ scope.row.defaultSpecValue ? scope.row.defaultSpecValue.stock : '-' }}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="selectProduct(scope.row)">
                    {{ $t('common.select') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pagination.page"
              :page-size="pagination.row"
              layout="total, prev, pager, next"
              :total="pagination.total"
              style="margin-top: 15px; text-align: right;">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryProductCategory } from '@/api/goods/productCategoryApi'
import { queryProduct } from '@/api/goods/productApi'
import { getShopId } from '@/api/shop/shopApi'
import { saveStaffCollectedProduct } from '@/api/goods/staffCollectedProductApi'
import { getUserInfo } from '@/api/user/indexApi'

export default {
  name: 'AddStaffCollectedProduct',
  data() {
    return {
      dialogVisible: false,
      categoryData: [],
      productList: [],
      loading: false,
      defaultProps: {
        children: 'children',
        label: 'categoryName'
      },
      searchForm: {
        prodNameLike: '',
        barCode: '',
        categoryId: ''
      },
      pagination: {
        page: 1,
        row: 10,
        total: 0
      },
      shopId: '',
      staffId: '',
      staffName: '',
      collectType: '1001'
    }
  },
  methods: {
    async open(collectType) {
      this.dialogVisible = true
      this.collectType = collectType || '1001'
      this._refreshChooseProductInfo()
      
      try {
        this.shopId = getShopId()
        const user = await getUserInfo()
        this.staffId = user.userId || ''
        this.staffName = user.name || ''
        
        // 加载商品分类和商品列表
        await this._listChooseProductCategorys()
        await this._loadAllProductInfo(1, 10)
      } catch (error) {
        console.error('获取信息失败:', error)
        this.$message.error('获取信息失败')
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this._refreshChooseProductInfo()
    },
    _refreshChooseProductInfo() {
      this.searchForm = {
        prodNameLike: '',
        barCode: '',
        categoryId: ''
      }
      this.productList = []
      this.pagination = {
        page: 1,
        row: 10,
        total: 0
      }
    },
    async _listChooseProductCategorys() {
      try {
        const params = {
          shopId: this.shopId,
          page: 1,
          row: 1000
        }
        const res = await queryProductCategory(params)
        // 构建树形结构
        const categories = res.data || []
        this.categoryData = this._buildCategoryTree(categories)
      } catch (error) {
        console.error('获取商品分类失败:', error)
      }
    },
    _buildCategoryTree(categories) {
      const map = {}
      const roots = []
      
      categories.forEach(category => {
        map[category.categoryId] = { ...category, children: [] }
      })
      
      categories.forEach(category => {
        if (category.parentCategoryId && map[category.parentCategoryId]) {
          map[category.parentCategoryId].children.push(map[category.categoryId])
        } else {
          roots.push(map[category.categoryId])
        }
      })
      
      return roots
    },
    handleNodeClick(data) {
      this.searchForm.categoryId = data.categoryId || ''
      this.pagination.page = 1
      this._loadAllProductInfo(1, this.pagination.row)
    },
    async _loadAllProductInfo(page, row) {
      this.loading = true
      try {
        const params = {
          page: page,
          row: row,
          shopId: this.shopId,
          prodNameLike: this.searchForm.prodNameLike,
          barCode: this.searchForm.barCode,
          categoryId: this.searchForm.categoryId
        }
        const res = await queryProduct(params)
        this.productList = res.data || []
        this.pagination.total = res.total || 0
        this.pagination.page = page
      } catch (error) {
        console.error('获取商品列表失败:', error)
        this.$message.error('获取商品列表失败')
      } finally {
        this.loading = false
      }
    },
    queryProducts() {
      this.pagination.page = 1
      this._loadAllProductInfo(1, this.pagination.row)
    },
    resetSearch() {
      this.searchForm.prodNameLike = ''
      this.searchForm.barCode = ''
      this.searchForm.categoryId = ''
      this.pagination.page = 1
      this._loadAllProductInfo(1, this.pagination.row)
    },
    handleCurrentChange(page) {
      this._loadAllProductInfo(page, this.pagination.row)
    },
    async selectProduct(product) {
      if (!product || !product.productId) {
        this.$message.warning(this.$t('staffCollectedProduct.selectProductFirst'))
        return
      }

      try {
        const defaultSpecValue = product.defaultSpecValue || {}
        const formData = {
          productId: product.productId,
          valueId: defaultSpecValue.valueId || '',
          prodName: product.prodName || '',
          specName: defaultSpecValue.specName || '',
          prodDesc: product.prodDesc || '',
          barCode: defaultSpecValue.barCode || '',
          collectType: this.collectType,
          sort: '0',
          shopId: this.shopId,
          staffId: this.staffId,
          staffName: this.staffName
        }
        
        await saveStaffCollectedProduct(formData)
        this.$emit('refresh')
        this.$message.success(this.$t('common.submitSuccess'))
        // 提交成功后关闭弹窗
        this.closeDialog()
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error(error || this.$t('common.submitFailed'))
      }
    }
  }
}
</script>

<style scoped>
.product-select-container {
  padding: 10px;
}

.product-category {
  border: 1px solid #ebeef5;
  padding: 10px;
  height: 500px;
  overflow-y: auto;
}

.product-list {
  min-height: 400px;
}

.search-container {
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
</style>
